import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledQuoteButtonsWrapper } from './styled';
import DownloadQuote from './download-quote';
import StartTrial from './start-trial';
import Contact from './contact';
import ComplianceDocuments from './compliance-documents';
const PortalButtons = ({ quotePortal }) => {
    const latestQuote = quotePortal.quotes[0];
    if (!latestQuote) {
        return null;
    }
    return (_jsxs(StyledQuoteButtonsWrapper, { children: [_jsx(DownloadQuote, { quotePortal: quotePortal }), _jsx(StartTrial, { quotePortal: quotePortal }), _jsx(Contact, { quote: latestQuote }), _jsx(ComplianceDocuments, {})] }));
};
export default PortalButtons;
